import type { ReactNode } from 'react';

import { cn } from '@repo/lib/cn';
import { ChevronDownIcon, XIcon } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';

interface FileUploadDrawerProps {
  callback?: () => void;
  children?: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function FileUploadDrawer(fileUploadDrawerProps: FileUploadDrawerProps) {
  const { open, onOpenChange, callback, children } = fileUploadDrawerProps;
  const [openCollapsible, setOpenCollapsible] = useState<boolean>(true);

  const collapsibleToggle = () => {
    setOpenCollapsible((prev) => !prev);
  };

  const onClose = () => {
    callback?.();
    onOpenChange(false);
    setOpenCollapsible(true);
  };

  return (
    <div
      className={cn(
        'border-border-primary bg-background fixed inset-x-0 right-0 bottom-0 left-0 z-20 mt-12 flex h-auto max-h-96 w-full flex-col rounded-t-lg border transition-transform duration-300 ease-in-out md:right-6 md:left-auto md:w-96',
        open ? 'translate-y-0' : 'pointer-events-none translate-y-full'
      )}
      aria-describedby={'file-upload-list'}
    >
      <header className={'flex w-full justify-end p-2'}>
        <h5 className="sr-only">File upload list</h5>

        <Button size={'sm'} variant={'ghost'} onClick={collapsibleToggle}>
          <ChevronDownIcon className={cn('transition-transform duration-200', !openCollapsible && 'rotate-180')} />
        </Button>
        <Button onClick={onClose} size={'sm'} variant={'ghost'}>
          <XIcon />
        </Button>
      </header>
      <div className={cn('h-full overflow-auto transition-all duration-300 ease-in-out', openCollapsible ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0')}>
        <div className={'flex h-full flex-col gap-2 p-4'}>{children}</div>
      </div>
    </div>
  );
}
